import { NavLink } from 'react-router-dom';
import NotFoundImg from '@/assets/illustrations/unauth2-illustration.svg';
import { buttonVariants } from '@/components/ui/button';
import TelletLogo from '@/assets/logo/tellet-logo-main.svg';
import Routes from '@/router/routes';

function Unauthorized() {
  return (
    <div className="relative flex items-center justify-center min-h-screen px-4 mx-auto text-center">
      <NavLink to={Routes.super_admin_dashboard.path}>
        <img src={TelletLogo} alt="logo" className="absolute w-24 h-fit top-5 left-5 dark:invert" />
      </NavLink>
      <div className="flex flex-col items-center justify-center gap-2 mx-auto text-center">
        <img
          src={NotFoundImg}
          alt="illustration"
          className="min500:w-full w-[450px]"
        />
        <h1 className="text-5xl font-bold mt-14 text-dark min500:text-4xl">Permission Denied</h1>
        <p className="mt-2 text-lg font-medium text-light-dark ">
          You lack the necessary permissions to view this page. <br /> For access or support, please
          contact our site administrator.
        </p>
        <NavLink
          to={Routes.super_admin_dashboard.path}
          className={buttonVariants({
            variant: 'default',
            className: 'mt-5 transition-all ease-in-out hover:!bg-darker-primary',
          })}
        >
          Back to home
        </NavLink>
      </div>
    </div>
  );
}

export default Unauthorized;
